import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export class CategorieService extends GenericLibelleService<CategorieModel> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTECATEGORIE, hostnameService);
  }

  GetFromActivite(idActivite: number): Observable<CategorieModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<CategorieModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromActivite?idActivite=' + idActivite)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
  GetFromCodeSociete(codeCategorie: string, idSociete: number): Observable<CategorieModel> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<CategorieModel>(APICONSTANTS.URLAPI.value + this.route + 'GetFromCodeSociete?codeCategorie=' + codeCategorie + '&idSociete=' + idSociete)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
  
}
